










import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/Auth/AppModule';

@Component({ name: 'Alert' })
export default class extends Vue {

    get errorCode() {
        // Note lastError can be null but lastError.code can also be undefined so check that first
        // and it can also be a number so convert to a string before trying to use toLowerCase
        if (AppModule.lastError && AppModule.lastError.code) {
            const codeAsString = AppModule.lastError.code + "";
            return codeAsString.toLowerCase();
        }
        else {
            return "Error";
        }
    }

    get errorMessage() {
        // Note lastError can be null but lastError.message can also be undefined
        return AppModule.lastError?.message ? AppModule.lastError.message : "Unknown error please check the console";
    }

    get showAlert() {
        return AppModule.lastErrorVisible;
    }

    set showAlert(value) {
        if (!value) {
            AppModule.clearErrorMessage();
        }
    }

    get showRefreshButton(){
        if (AppModule.lastError != null) {
            return AppModule.lastError.showRefreshButton;
        }
        else {
            return false;
        }
    }

}
